export enum QueryKey {
  deletePost = 'deletePost',
  getPost = 'getPost',
  getSections = 'getSections',
  savePost = 'savePost',
}
